import { TYPES } from '../actions';

const initialState = {
  transactions: [],
  currentTransaction: null,
  totalCount: 0,
  loading: false,
  error: null
};

export const sivProductInventoryTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTIONS_SUCCESS:
      console.log("action.payload.data", action.payload);
      return {
        ...state,
        transactions: action.payload.result,
        totalCount: action.payload.totalCount || state.totalCount,
        loading: false,
        error: null
      };

    case TYPES.ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTION_BY_ID_SUCCESS:
      return {
        ...state,
        currentTransaction: action.payload.data,
        loading: false,
        error: null
      };

    case TYPES.ACTION_SET_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS:
      return {
        ...state,
        transactions: [...state.transactions, action.payload.data],
        loading: false,
        error: null
      };

    case TYPES.ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS:
      return {
        ...state,
        transactions: state.transactions.map(transaction => 
          transaction._id === action.payload.data._id ? action.payload.data : transaction
        ),
        currentTransaction: action.payload.data,
        loading: false,
        error: null
      };

    case TYPES.ACTION_DELETE_SIV_PRODUCT_INVENTORY_TRANSACTION_SUCCESS:
      return {
        ...state,
        transactions: state.transactions.filter(transaction => transaction._id !== action.payload.data._id),
        loading: false,
        error: null
      };

    case TYPES.ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_DATE_SUCCESS:
      return {
        ...state,
        transactions: state.transactions.map(transaction => 
          transaction._id === action.payload._id ? { ...transaction, transaction_date: action.payload.transaction_date } : transaction
        ),
        currentTransaction: state.currentTransaction && state.currentTransaction._id === action.payload._id 
          ? { ...state.currentTransaction, transaction_date: action.payload.transaction_date }
          : state.currentTransaction,
        loading: false,
        error: null
      };

    case TYPES.ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTIONS_FAIL:
    case TYPES.ACTION_GET_SIV_PRODUCT_INVENTORY_TRANSACTION_BY_ID_FAIL:
    case TYPES.ACTION_SET_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL:
    case TYPES.ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL:
    case TYPES.ACTION_DELETE_SIV_PRODUCT_INVENTORY_TRANSACTION_FAIL:
    case TYPES.ACTION_UPDATE_SIV_PRODUCT_INVENTORY_TRANSACTION_DATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}; 